/**
 * @file FooterScriptsSlot.tsx
 *
 * @fileoverview Prints custom scripts on the site head.
 */

import React from 'react';

export const FooterScriptsSlot = () => {
  return <></>;
};
export default FooterScriptsSlot;
